export type Deadline = { closeAt: number; durationMs: number };

export function armDeadline(now: number, durationMs: number): Deadline {
  return { closeAt: now + durationMs, durationMs };
}

export function remainingMs(deadline: Deadline, now: number): number {
  return Math.max(0, deadline.closeAt - now);
}

export function progressLeft(deadline: Deadline, now: number): number {
  if (deadline.durationMs <= 0) return 0;
  return Math.min(1, remainingMs(deadline, now) / deadline.durationMs);
}

export function isExpired(deadline: Deadline, now: number): boolean {
  return now >= deadline.closeAt;
}
